import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  root: {
    flexDirection: 'row',
  },
  column: {
    flex: 1,
  },
  columnInner: {
    marginRight: 12,
  },
  rightAlignColumn: {
    flex: 1,
    alignItems: 'flex-end',
  },
});
